export type {
  SavedProject,
  Follow,
  DropUpdate,
  CreatorMetric,
  WorkspaceData,
} from "./workspace-types";
export async function workspaceRequest<T>(
  authorization: string,
  path = "",
  body?: unknown,
  method = body === undefined ? "GET" : "POST",
): Promise<T> {
  const response = await fetch(`/api/workspace${path}`, {
    method,
    headers: {
      authorization: `Bearer ${authorization}`,
      "content-type": "application/json",
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const data: unknown = await response.json();
  if (!response.ok)
    throw new Error(
      (data as { error?: string }).error || "Workspace request failed",
    );
  return data as T;
}
export function recordFunnelEvent(launchId: string, event: "view" | "review") {
  try {
    const key = "stc:funnel-session";
    let visitor = sessionStorage.getItem(key);
    if (!visitor) {
      visitor = crypto.randomUUID();
      sessionStorage.setItem(key, visitor);
    }
    void fetch(`/api/workspace/events/${encodeURIComponent(launchId)}`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ visitor, event }),
    }).catch(() => undefined);
  } catch {
    /* Analytics must never interrupt minting. */
  }
}
